import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { BubbleButton } from '../../containers/hrAssistant/BubbleButton.jsx';
import HrAssistantContainer from '../../containers/hrAssistant/HrAssistantContainer.jsx';

export const InternalChatBot = ({ assistantUuid }) => {
  const chatIframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = e => {
      if (!chatIframeRef.current) return;
      if (e.data === 'openChat') {
        chatIframeRef.current.style.display = 'block';
      } else if (e.data === 'closeChat') {
        chatIframeRef.current.style.display = 'none';
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      <ButtonWrapper>
        <BubbleButton />
      </ButtonWrapper>
      <HrAssistantWrapper id="chat-iframe" ref={chatIframeRef}>
        <HrAssistantContainer embed={true} assistantUuid={assistantUuid} />
      </HrAssistantWrapper>
    </>
  );
};

const ButtonWrapper = styled.div`
  position: fixed !important;
  height: 60px;
  width: 60px;
  bottom: 20px;
  right: 20px;
  z-index: 2147483647;
  border: none;
`;

const HrAssistantWrapper = styled.div`
  position: fixed !important;
  height: min(600px, calc(100vh - 101px));
  height: min(600px, calc(100dvh - 101px));
  width: min(400px, calc(100vw - 32px));
  bottom: 85px;
  right: min(25px, 4vw);
  z-index: 2147483647;
  display: none;
  border: none;
`;
